import {
    numberWithCommas,
    secondsToHumanReadableDuration,
    metersToKiloMeters,
    unixStringToHumanReadable,
    getZoomLevelFromDistance,
    unixTimestampToRelativeHumanReadable,
} from '../../common/utils';

export const transformSegments = (segments) => {
    if (segments && segments.length) {
        return segments.map((segment) => {
            return {
                id: segment.id,
                name: segment.fullName,
                date: unixStringToHumanReadable(segment.startTime),
                avatar: segment.profilePicture,
                litterCount: numberWithCommas(segment.litterCount),
                distance: segment.distance
                    ? metersToKiloMeters(segment.distance)
                    : '0 M',
                zoomLevel: segment.distance
                    ? getZoomLevelFromDistance(segment.distance)
                    : 13.0,
                duration: segment.duration
                    ? secondsToHumanReadableDuration(segment.duration)
                    : '0 SEC',
                location:
                    segment.location && segment.location.length
                        ? segment.location.map((location) => {
                              return {
                                  lat: parseFloat(location.lat),
                                  lng: parseFloat(location.long),
                              };
                          })
                        : [],
            };
        });
    } else {
        return [];
    }
};

export const transformNotifications = (notifications) => {
    if (notifications && notifications.length) {
        return notifications.map((notification) => {
            return {
                id: notification.id,
                title: notification.title,
                date: unixTimestampToRelativeHumanReadable(
                    notification.createdAt,
                ),
                message: notification.message,
                contextKey: notification.contextKey,
                contextValue: notification.contextValue,
            };
        });
    } else {
        return [];
    }
};

/**
 * Given an array of Challenge codes, produce drop-down items for each code that has users and litters.
 *
 * @param {array} codes - Challenge code objects containing { codeId, code, totalUsers, totalLitters }
 * @returns Array of Challenge code items to add to the Top Contributors: Team drop-down list
 */
export const transformChallengeCodes = (codes) => {
    if (codes && codes.length) {
        const codesForChallenge = codes
            .filter((c) => c.code && c.totalUsers && c.totalLitters)
            .map((c) => {
                return {
                    key: c.codeId,
                    id: c.codeId,
                    label: c.code,
                };
            });
        return [{ key: 'all', id: 'all', label: 'all' }, ...codesForChallenge];
    } else {
        return [];
    }
};
